import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-17-kr-jyothilal-guest.webp";
import ThumbImg from "../../assets/images/conversations/017.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";
import FacebookIcon from "../../assets/icons/conversations/facebook.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";
import TwitterIcon  from "../../assets/icons/conversations/twitter.svg";

/* ─────────────────────────────────────────────
   PREFIX: kj-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .kj-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .kj-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .kj-hero { padding-top: 60px; padding-bottom: 60px; }
  .kj-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .kj-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .kj-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kj-hero__title.kj-visible { opacity: 1; transform: translateY(0); }

  /* social share buttons */
  .kj-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .kj-hero__social.kj-visible { opacity: 1; transform: translateY(0); }
  .kj-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .kj-hero__social a:hover { opacity: 0.85; }
  .kj-hero__social a.fb { background: #3B5998; }
  .kj-hero__social a.li { background: #0077B5; }
  .kj-hero__social a.tw { background: #1DA1F2; }
  .kj-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .kj-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .kj-hero__spotify.kj-visible { opacity: 1; transform: translateY(0); }
  .kj-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .kj-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .kj-hero__right.kj-visible { opacity: 1; transform: translateY(0); }

  .kj-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .kj-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .kj-yt-thumb:hover img { opacity: 0.85; }
  .kj-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .kj-yt-thumb__play img { width: 40px; height: 44px; }
  .kj-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .kj-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .kj-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kj-body.kj-visible { opacity: 1; transform: translateY(0); }
  .kj-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .kj-body__para:last-child { margin-bottom: 0; }

  .kj-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kj-guest.kj-visible { opacity: 1; transform: translateY(0); }
  .kj-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .kj-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .kj-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .kj-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .kj-inner { padding-left: 32px; padding-right: 32px; }
    .kj-hero { padding-top: 32px; padding-bottom: 48px; }
    .kj-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .kj-hero__title { font-size: 24px; }
    .kj-hero__left { gap: 16px; }
    .kj-hero__social { gap: 10px; }
    .kj-hero__social a { gap: 10px; font-size: 12px; padding: 10px 12px; }
    .kj-guest__title { font-size: 24px; margin-bottom: 24px; }
    .kj-guest__photo-bg { width: 260px; height: 300px; }
    .kj-guest__name { font-size: 24px; margin-top: 18px; }
    .kj-body__para { font-size: 14px; margin-bottom: 12px; }
    .kj-body { padding-bottom: 48px; }
    .kj-guest { padding-bottom: 48px; }
    .kj-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .kj-inner { padding-left: 16px; padding-right: 16px; }
    .kj-hero { padding-top: 51px; padding-bottom: 30px; }
    .kj-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .kj-hero__left { gap: 30px; }
    .kj-hero__title { font-size: 30px; }
    .kj-hero__social { gap: 11px; }
    .kj-hero__social a { gap: 10px; font-size: 15px; padding: 10px 14px; }
    .kj-body__para { font-size: 16px; margin-bottom: 10px; }
    .kj-guest__title { font-size: 30px; margin-bottom: 20px; }
    .kj-guest__photo-bg { width: 100%; height: 386px; }
    .kj-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .kj-body { padding-bottom: 30px; }
    .kj-guest { padding-bottom: 30px; }
    .kj-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("kj-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP17_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="kj-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 17 K.R. Jyothilal IAS"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="kj-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 17 K.R. Jyothilal IAS thumbnail" />
      <div className="kj-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="kj-hero">
      <div className="kj-inner">
        <div className="kj-hero__grid">
          <div className="kj-hero__left">
            <div ref={titleRef} className="kj-hero__title">
              EP 17 | What does it take to build India's most electrified state for zero-emission mobility | K.R. JYOTHILAL IAS
            </div>
            <div ref={socialRef} className="kj-hero__social">
              <a href="https://www.facebook.com/sharer/sharer.php?u=" className="fb" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" /> Facebook
              </a>
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" /> Linked in
              </a>
              <a href="https://twitter.com/intent/tweet?url=" className="tw" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" /> Twitter
              </a>
            </div>
            <div ref={spotifyRef} className="kj-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/54mTPPPAhajJKq0wuwAxE6?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 17 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="kj-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="kj-body">
      <div className="kj-inner">
        <p className="kj-body__para">
          Today our show meets someone very interesting as we feature a senior policymaker and regulator for the transport sector in one of India's most progressive states, Kerala. In this very engaging conversation, we cover how the great CORONA lockdowns impacted mobility and the economy of the state. We also discuss why Kerala has some of the most progressive EV implementation policies in India and how the state expects to achieve its target of 1 million vehicles converted to Zero-Emission Mobility within the next 3 years. We also talked about why Kerela has embarked on hydrogen mobility for public transportation including buses and boat ferries.
        </p>
        <p className="kj-body__para">
          We talked today with the Principal Secretary Transport for the state of Kerala Mr. Jyotilal who has had a distinguished career across India as part of the Indian Administrative Service or IAS and has a reputation for pushing the boundaries of what is possible on all fronts, policy, regulation as well as technology and it happens.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="kj-guest">
      <div className="kj-inner">
        <h2 className="kj-guest__title">Our Guest</h2>
        <div>
          <div className="kj-guest__photo-bg">
            <img src={GuestImg} alt="K.R. Jyothilal IAS" />
          </div>
          <p className="kj-guest__name">K.R. JYOTHILAL IAS</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep17KRJyothilal() {
  return (
    <>
      <style>{CSS}</style>
      <div className="kj-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}